import { render } from "./mechanismsetup.vue?vue&type=template&id=3aad1cbd&scoped=true"
import script from "./mechanismsetup.vue?vue&type=script&lang=js"
export * from "./mechanismsetup.vue?vue&type=script&lang=js"

import "./mechanismsetup.vue?vue&type=style&index=0&id=3aad1cbd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3aad1cbd"

export default script